/* ---------------------------------------------------------
   UPDATE CART BUBBLE
--------------------------------------------------------- */
function updateCartIconBubbleFromCart() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const count = cart.item_count || 0;
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;

      let bubble = cartIcon.querySelector('.cart-count-bubble');

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble here';
        bubble.innerHTML = `
          <span aria-hidden="true">${count}</span>
          <span class="visually-hidden">${count}</span>
        `;
        cartIcon.appendChild(bubble);
      } else {
        bubble.innerHTML = `
          <span aria-hidden="true">${count}</span>
          <span class="visually-hidden">${count}</span>
        `;
      }

      // Update floating cart icon count
      updateFloatingCartIcon(count);
    })
    .catch((err) => {
      console.error('Error obteniendo el carrito:', err);
    });
}

/* ---------------------------------------------------------
   FLOATING CART ICON - Show/Hide Based on Cart State
--------------------------------------------------------- */
/* ---------------------------------------------------------
   FLOATING CART ICON - Show/Hide Based on Cart State
--------------------------------------------------------- */
/* ---------------------------------------------------------
   FLOATING CART ICON - Show/Hide Based on Cart State
--------------------------------------------------------- */
/* ---------------------------------------------------------
   FLOATING CART ICON - Show/Hide Based on Cart State
--------------------------------------------------------- */
function createFloatingCartIcon() {
  // Remove existing icon if any
  const existingIcon = document.getElementById('floating-cart-icon');
  if (existingIcon) {
    existingIcon.remove();
  }

  const floatingIcon = document.createElement('div');
  floatingIcon.id = 'floating-cart-icon';
  floatingIcon.style.cssText = `
    position: fixed !important;
    right: 20px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 50px !important;
    height: 50px !important;
    background: rgb(235, 235, 235) !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    z-index: 999997 !important;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px !important;
    transition: all 0.3s ease !important;
    opacity: 0 !important;
  `;

  floatingIcon.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2">
      <circle cx="9" cy="21" r="1"/>
      <circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
    <div id="floating-cart-count" style="
      position: absolute;
      top: -2px;
      right: -2px;
      background: #000;
      color: #fff;
      border-radius: 50%;
      width: 15px;
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: bold;
    ">0</div>
  `;

  // Hover effect
  floatingIcon.addEventListener('mouseenter', () => {
    floatingIcon.style.transform = 'translateY(-50%) scale(1.1)';
  });

  floatingIcon.addEventListener('mouseleave', () => {
    floatingIcon.style.transform = 'translateY(-50%) scale(1)';
  });

  // Click to open cart - FAST VERSION
  floatingIcon.addEventListener('click', async () => {
    console.log("🛒 Floating cart icon clicked!");
    
    const drawer = document.querySelector("cart-drawer");
    
    if (!drawer) {
      window.location.href = "/cart";
      return;
    }
    
    // Hide floating icon immediately
    hideFloatingCartIcon();
    
    // Native Shopify open (fastest)
    if (typeof drawer.open === "function") {
      drawer.open();
    }
    
    // Force show with mobile-friendly positioning
    drawer.setAttribute("open", "");
    drawer.classList.add("active");
    
    // Check if mobile
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Mobile: Full width drawer
      drawer.style.setProperty("position", "fixed", "important");
      drawer.style.setProperty("left", "0", "important");
      drawer.style.setProperty("right", "0", "important");
      drawer.style.setProperty("top", "0", "important");
      drawer.style.setProperty("bottom", "0", "important");
      drawer.style.setProperty("width", "100%", "important");
      drawer.style.setProperty("max-width", "100%", "important");
    } else {
      // Desktop: Right side drawer
      drawer.style.setProperty("position", "fixed", "important");
      drawer.style.setProperty("left", "auto", "important");
      drawer.style.setProperty("right", "0", "important");
      drawer.style.setProperty("top", "0", "important");
      drawer.style.setProperty("bottom", "0", "important");
      drawer.style.setProperty("max-width", "400px", "important");
      drawer.style.setProperty("width", "100%", "important");
    }
    
    drawer.style.setProperty("height", "100vh", "important");
    drawer.style.setProperty("display", "flex", "important");
    drawer.style.setProperty("visibility", "visible", "important");
    drawer.style.setProperty("opacity", "1", "important");
    drawer.style.setProperty("transform", "translateX(0)", "important");
    drawer.style.setProperty("z-index", "999999", "important");
    drawer.style.setProperty("flex-direction", "column", "important");
    drawer.style.setProperty("margin", "0", "important");
    drawer.style.setProperty("padding", "0", "important");
    
    // Add effects
    addPageBlur();
    applyCustomCartStyles();
    setupCartCloseButton();
    startCartDrawerObserver();
  });

  document.body.appendChild(floatingIcon);
  console.log("✅ Floating cart icon created");
  
  // Show icon with fade-in after creation
  setTimeout(() => {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = cart.item_count || 0;
        updateFloatingCartIcon(count);
      });
  }, 100);
}
function updateFloatingCartIcon(count) {
  let floatingIcon = document.getElementById('floating-cart-icon');
  
  if (!floatingIcon) {
    createFloatingCartIcon();
    floatingIcon = document.getElementById('floating-cart-icon');
    return; // ✅ Return after creating, let initialization handle it
  }

  const countBadge = document.getElementById('floating-cart-count');
  if (countBadge) {
    countBadge.textContent = count;
  }

  // Show icon with fade if cart has items
  if (count > 0) {
    floatingIcon.style.setProperty('display', 'flex', 'important');
    // Small delay for smooth fade-in
    setTimeout(() => {
      floatingIcon.style.setProperty('opacity', '1', 'important');
    }, 50);
  } else {
    floatingIcon.style.setProperty('opacity', '0', 'important');
    setTimeout(() => {
      floatingIcon.style.setProperty('display', 'none', 'important');
    }, 300);
  }
}

function hideFloatingCartIcon() {
  const floatingIcon = document.getElementById('floating-cart-icon');
  if (floatingIcon) {
    floatingIcon.style.setProperty('display', 'none', 'important');
  }
}

function showFloatingCartIcon() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const count = cart.item_count || 0;
      if (count > 0) {
        updateFloatingCartIcon(count);
      }
    });
}

/* ---------------------------------------------------------
   BACKGROUND BLUR FUNCTIONS
--------------------------------------------------------- */
function addPageBlur() {
  console.log("🌫️ Adding page blur...");
  console.log("📍 Current body children:", document.body.children.length);
  
  let blurOverlay = document.getElementById('cart-blur-overlay');
  
  if (!blurOverlay) {
    console.log("✨ Creating NEW blur overlay element");
    blurOverlay = document.createElement('div');
    blurOverlay.id = 'cart-blur-overlay';
    blurOverlay.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      background: rgba(0, 0, 0, 0.05) !important;
      backdrop-filter: blur(0.70px) !important;
      -webkit-backdrop-filter: blur(0.70px) !important;
      z-index: 999998 !important;
      pointer-events: auto !important;
      opacity: 0 !important;
      transition: opacity 0.3s !important;
      display: block !important;
    `;
    document.body.appendChild(blurOverlay);
    console.log("✅ Blur overlay ADDED to body");
    console.log("📦 Blur overlay element:", blurOverlay);
  } else {
    console.log("♻️ Blur overlay ALREADY EXISTS, reusing it");
    blurOverlay.style.setProperty("display", "block", "important");
  }
  
  blurOverlay.addEventListener('click', function() {
    console.log("🖱️ Blur overlay CLICKED!");
    closeCartDrawer();
  });
  
  // Fade in the blur
  setTimeout(() => {
    blurOverlay.style.opacity = '1';
    console.log("✅ Blur opacity set to 1");
  }, 10);
  
  console.log("✅ Page blur added");
}

function removePageBlur() {
  console.log("🌫️ Removing page blur...");
  
  const blurOverlay = document.getElementById('cart-blur-overlay');
  
  if (blurOverlay) {
    console.log("✅ Found blur overlay, removing...");
    // Fade out
    blurOverlay.style.opacity = '0';
    
    // Remove after transition
    setTimeout(() => {
      if (blurOverlay.parentNode) {
        blurOverlay.parentNode.removeChild(blurOverlay);
        console.log("✅ Blur overlay REMOVED from DOM");
      }
    }, 300);
  } else {
    console.log("⚠️ Blur overlay NOT FOUND in DOM");
  }
  
  console.log("✅ Page blur removed");
}

/* ---------------------------------------------------------
   LOADING SPINNER FUNCTIONS
--------------------------------------------------------- */
function showLoadingSpinner(button) {
  if (!button) return;
  console.log("⏳ Showing loading spinner...");
  
  // Store original text
  button.dataset.originalText = button.textContent;
  
  // Create spinner HTML
  button.innerHTML = `
    <span style="display: inline-flex; align-items: center; gap: 8px;">
      <svg style="animation: spin 1s linear infinite; width: 16px; height: 16px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25"/>
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <span>Loading...</span>
    </span>
  `;
  
  button.disabled = true;
  
  // Add spinner animation style if not exists
  if (!document.head.querySelector('style[data-spinner-animation]')) {
    const style = document.createElement('style');
    style.setAttribute('data-spinner-animation', 'true');
    style.textContent = `
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
  
  console.log("✅ Spinner shown");
}

function hideLoadingSpinner(button) {
  if (!button) return;
  console.log("⏳ Hiding loading spinner...");
  
  const originalText = button.dataset.originalText || "View Cart";
  button.textContent = originalText;
  button.disabled = false;
  
  console.log("✅ Spinner hidden");
}

/* ---------------------------------------------------------
   APPLY CUSTOM CART STYLES (Reusable Function)
--------------------------------------------------------- */
function applyCustomCartStyles() {
  if (cartObserver) cartObserver.disconnect();
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;

  console.log("🎨 Applying custom cart styles...");

  // Fix inner container - REMOVE ALL PADDING
  const innerSelectors = [
    ".drawer__inner",
    ".cart-drawer__inner", 
    ".cart--drawer__inner",
    "[class*='drawer__inner']",
    "[class*='cart-drawer']",
    ".drawer__content"
  ];
  
  for (const selector of innerSelectors) {
    const inner = drawer.querySelector(selector);
    if (inner) {
      inner.style.setProperty("transform", "translateX(0)", "important");
      inner.style.setProperty("right", "0", "important");
      inner.style.setProperty("left", "auto", "important");
      inner.style.setProperty("opacity", "1", "important");
      inner.style.setProperty("visibility", "visible", "important");
      inner.style.setProperty("display", "flex", "important");
      inner.style.setProperty("flex-direction", "column", "important");
      inner.style.setProperty("height", "100%", "important");
      inner.style.setProperty("width", "100%", "important");
      inner.style.setProperty("margin", "0", "important");
      inner.style.setProperty("padding", "0", "important");
    }
  }
  
  // Fix cart HEADER section
  const headerSelectors = [
    ".drawer__header",
    ".cart-drawer__header",
    ".cart__header",
    "[class*='drawer__header']",
    "cart-drawer-items",
    ".cart-drawer-items"
  ];
  
  for (const selector of headerSelectors) {
    const header = drawer.querySelector(selector);
    if (header) {
      header.style.setProperty("padding", "1.5rem 1.5rem 1rem 1.5rem", "important");
      header.style.setProperty("margin", "0", "important");
      header.style.setProperty("flex-shrink", "0", "important");
    }
  }
  
  // Fix "Your cart" heading
  const cartHeadings = drawer.querySelectorAll("h2, .drawer__heading, [class*='heading']");
  cartHeadings.forEach(heading => {
    if (heading.textContent.includes("Your cart") || heading.textContent.includes("cart")) {
      heading.style.setProperty("margin", "0", "important");
      heading.style.setProperty("padding", "0", "important");
    }
  });
  
  // Fix cart items container
  const cartItemsSelectors = [
    ".drawer__content",
    ".cart-drawer__content",
    ".cart__items",
    ".cart-items",
    "[class*='cart-items']",
    "[class*='drawer-content']"
  ];
  
  for (const selector of cartItemsSelectors) {
    const itemsContainer = drawer.querySelector(selector);
    if (itemsContainer) {
      itemsContainer.style.setProperty("flex", "1 1 auto", "important");
      itemsContainer.style.setProperty("overflow-y", "auto", "important");
      itemsContainer.style.setProperty("overflow-x", "hidden", "important");
      itemsContainer.style.setProperty("max-height", "calc(100vh - 30px)", "important");
      itemsContainer.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
      itemsContainer.style.setProperty("padding", "0 1.5rem 1.5rem 1.5rem", "important");
      itemsContainer.style.setProperty("margin", "0", "important");
      itemsContainer.style.setProperty("scrollbar-width", "none", "important");
      itemsContainer.style.setProperty("-ms-overflow-style", "none", "important");
    }
  }
  
  // Webkit scrollbar hide (one-time setup)
  if (!document.head.querySelector('style[data-cart-scrollbar]')) {
    const style = document.createElement('style');
    style.setAttribute('data-cart-scrollbar', 'true');
    style.textContent = `
      cart-drawer .drawer__content::-webkit-scrollbar,
      cart-drawer .cart-drawer__content::-webkit-scrollbar,
      cart-drawer .cart__items::-webkit-scrollbar,
      cart-drawer [class*='cart-items']::-webkit-scrollbar {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // Fix individual cart items
  const allCartItems = drawer.querySelectorAll('.cart-item, [class*="cart-item"], cart-item');
  allCartItems.forEach(item => {
    item.style.setProperty("padding-left", "0", "important");
    item.style.setProperty("padding-right", "0", "important");
    item.style.setProperty("margin-left", "0", "important");
    item.style.setProperty("margin-right", "0", "important");
  });
  
  // Fix footer
  const footerSelectors = [
    ".drawer__footer",
    ".cart-drawer__footer",
    ".cart__footer",
    ".totals",
    "[class*='footer']",
    "[class*='total']"
  ];
  
  for (const selector of footerSelectors) {
    const footer = drawer.querySelector(selector);
    if (footer && (footer.textContent.includes('Estimated total') || footer.querySelector('[class*="total"]'))) {
      footer.style.setProperty("position", "sticky", "important");
      footer.style.setProperty("bottom", "0", "important");
      footer.style.setProperty("left", "0", "important");
      footer.style.setProperty("right", "0", "important");
      footer.style.setProperty("margin", "0", "important");
      footer.style.setProperty("flex-shrink", "0", "important");
      footer.style.setProperty("background", "#fff", "important");
      footer.style.setProperty("padding", "1rem 1.5rem", "important");
      footer.style.setProperty("z-index", "100", "important");
      footer.style.setProperty("width", "100%", "important");
    }
  }
  
  // Fix footer text alignment
  const footerTexts = drawer.querySelectorAll('.drawer__footer *, .cart-drawer__footer *, .cart__footer *');
  footerTexts.forEach(text => {
    text.style.setProperty("padding-left", "0", "important");
    text.style.setProperty("margin-left", "0", "important");
  });
  
  const totalsWrapper = drawer.querySelector(".totals");
  if (totalsWrapper) {
    totalsWrapper.style.setProperty("padding-top", "0.2rem", "important");
    totalsWrapper.style.setProperty("margin-top", "0", "important");
  }

  console.log("✅ Custom styles applied!");
  setTimeout(() => startCartDrawerObserver(), 200);
}

function setupRemoveButtons() {
  const removeButtons = document.querySelectorAll('[data-cart-remove], .cart-remove, button[name="remove"], .remove-item');

  removeButtons.forEach((btn) => {
    btn.removeEventListener("click", handleRemoveClick); 
    btn.addEventListener("click", handleRemoveClick);
  });

  console.log("🛠 Remove buttons attached:", removeButtons.length);
}

function handleRemoveClick(e) {
  console.log("🗑 Product delete clicked", e.target);

  // Shopify ko time do item delete karne ka
  setTimeout(() => {
    console.log("🎨 Re-applying custom CSS after delete...");
    applyCustomCartStyles();
    setupRemoveButtons();
    updateCartIconBubbleFromCart();
  }, 2000);
}

/* ---------------------------------------------------------
   MUTATION OBSERVER - Watch Cart Drawer Changes
--------------------------------------------------------- */
let cartObserver = null;

function startCartDrawerObserver() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;

  // Stop existing observer if any
  if (cartObserver) {
    cartObserver.disconnect();
  }

  console.log("👁️ Starting cart drawer observer...");

  cartObserver = new MutationObserver((mutations) => {
    let shouldReapplyStyles = false;

    mutations.forEach((mutation) => {
      if (mutation.removedNodes.length > 0) {
        console.log("🗑 Item removed from cart DOM");
        shouldReapplyStyles = true;
      }
      // Check if cart items were modified
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        const target = mutation.target;
        
        // Detect if cart content changed
        if (
          (target.matches && (
            target.matches('.cart-items, .cart-item, cart-drawer-items, .drawer__content')
          )) ||
          (target.closest && target.closest('.cart-items, .cart-item, cart-drawer-items, .drawer__content'))
        ) {
          shouldReapplyStyles = true;
        }
      }
    });

    if (shouldReapplyStyles) {
      console.log("🔄 Cart DOM changed - reapplying styles...");
      
      // Small delay to let Shopify finish rendering
      setTimeout(() => {
        applyCustomCartStyles();
        setupCartCloseButton();
        setupRemoveButtons();
      }, 100);
    }
  });

  // Observe drawer with all child changes
  cartObserver.observe(drawer, {
    childList: true,
    subtree: true,
    attributes: false
  });

  console.log("✅ Observer started!");
}

/* ---------------------------------------------------------
   FORCE RELOAD CART DRAWER - COMPLETE REFRESH
--------------------------------------------------------- */
async function forceReloadCartDrawer() {
  console.log("🔄 Force reloading cart drawer...");
  
  try {
    // Get fresh cart data
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    console.log("Cart items:", cartData.item_count);
    
    // Get fresh cart drawer HTML
    const response = await fetch(window.location.pathname + '?sections=cart-drawer');
    const data = await response.json();
    
    if (data['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newDrawerContent = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      
      if (currentDrawer && newDrawerContent) {
        // Save open state
        const wasOpen = currentDrawer.hasAttribute('open');
        
        // Replace entire drawer content
        currentDrawer.innerHTML = newDrawerContent.innerHTML;
        
        // Copy attributes
        Array.from(newDrawerContent.attributes).forEach(attr => {
          currentDrawer.setAttribute(attr.name, attr.value);
        });
        
        console.log("✅ Drawer content replaced");
        
        // Wait for DOM update
        await new Promise(r => setTimeout(r, 200));
        
        return true;
      }
    }
    
    return false;
  } catch (error) {
    console.error("❌ Error reloading drawer:", error);
    return false;
  }
}

/* ---------------------------------------------------------
   CLOSE CART DRAWER
--------------------------------------------------------- */
function closeCartDrawer() {
  console.log("❌ Closing drawer...");
  
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) {
    console.log("⚠️ Drawer element not found!");
    return;
  }
  
  console.log("✅ Drawer found, proceeding to close...");
  
  // Remove blur from page
  removePageBlur();
  console.log("✅ removePageBlur() COMPLETED");
  
  // Show floating cart icon when drawer closes
  showFloatingCartIcon();
  
  // Stop observer when closing
  if (cartObserver) {
    cartObserver.disconnect();
    cartObserver = null;
  }
  
  // Try native close method
  if (typeof drawer.close === "function") {
    try {
      drawer.close();
      console.log("✅ Native close() executed");
    } catch(e) {
      console.log("⚠️ Native close failed:", e);
    }
  }
  
  // Force close with !important styles
  drawer.removeAttribute("open");
  drawer.classList.remove("active", "animate");
  
  // FORCE HIDE THE DRAWER
  drawer.style.setProperty("transform", "translateX(100%)", "important");
  drawer.style.setProperty("opacity", "0", "important");
  drawer.style.setProperty("visibility", "hidden", "important");
  drawer.style.setProperty("display", "none", "important");
  
  console.log("✅ Drawer styles reset");
  
  // Hide ALL overlays
  const overlaySelectors = [
    ".cart-drawer__overlay",
    "#CartDrawer-Overlay", 
    "[id*='Overlay']",
    "[class*='overlay']"
  ];
  
  overlaySelectors.forEach(selector => {
    const overlays = document.querySelectorAll(selector);
    overlays.forEach(overlay => {
      overlay.classList.remove("active");
      overlay.style.setProperty("opacity", "0", "important");
      overlay.style.setProperty("visibility", "hidden", "important");
      overlay.style.setProperty("display", "none", "important");
    });
  });
  
  console.log("✅ Overlays hidden");
  
  // Restore body scroll
  document.body.style.overflow = "";
  document.body.classList.remove("overflow-hidden");
  
  console.log("✅✅✅ Drawer closed successfully!");
}

/* ---------------------------------------------------------
   OPEN CART DRAWER WITH CONSISTENT ALIGNMENT
--------------------------------------------------------- */
async function openCartDrawerWithProducts(button) {
  console.log("🚀 Opening cart drawer with products...");
  
  if (button) {
    showLoadingSpinner(button);
  }
  
  hideFloatingCartIcon();
  
  const reloaded = await forceReloadCartDrawer();
  
  if (!reloaded) {
    console.log("⚠️ Fallback: Redirecting to /cart");
    if (button) hideLoadingSpinner(button);
    window.location.href = "/cart";
    return;
  }
  
  const drawer = document.querySelector("cart-drawer");
  
  if (!drawer) {
    console.log("❌ Drawer not found after reload");
    if (button) hideLoadingSpinner(button);
    window.location.href = "/cart";
    return;
  }
  
  console.log("✅ Drawer element found");
  
  if (typeof drawer.open === "function") {
    try {
      drawer.open();
      console.log("✅ Native open() called");
    } catch(e) {
      console.log("⚠️ Native open failed:", e);
    }
  }
  
  drawer.setAttribute("open", "");
  drawer.classList.add("active", "animate");
  
  // Check if mobile
  const isMobile = window.innerWidth <= 768;
  
  drawer.style.setProperty("position", "fixed", "important");
  drawer.style.setProperty("top", "0", "important");
  drawer.style.setProperty("bottom", "0", "important");
  drawer.style.setProperty("height", "100vh", "important");
  drawer.style.setProperty("opacity", "1", "important");
  drawer.style.setProperty("visibility", "visible", "important");
  drawer.style.setProperty("transform", "translateX(0)", "important");
  drawer.style.setProperty("z-index", "999999", "important");
  drawer.style.setProperty("display", "flex", "important");
  drawer.style.setProperty("flex-direction", "column", "important");
  drawer.style.setProperty("margin", "0", "important");
  drawer.style.setProperty("padding", "0", "important");
  
  if (isMobile) {
    // Mobile: Full width
    drawer.style.setProperty("left", "0", "important");
    drawer.style.setProperty("right", "0", "important");
    drawer.style.setProperty("width", "100%", "important");
    drawer.style.setProperty("max-width", "100%", "important");
  } else {
    // Desktop: Right side
    drawer.style.setProperty("left", "auto", "important");
    drawer.style.setProperty("right", "0", "important");
    drawer.style.setProperty("max-width", "400px", "important");
    drawer.style.setProperty("width", "100%", "important");
  }
  
  applyCustomCartStyles();
  setupRemoveButtons();
  
  const overlaySelectors = [
    ".cart-drawer__overlay",
    "#CartDrawer-Overlay",
    "[id*='Overlay']"
  ];
  
  for (const selector of overlaySelectors) {
    const overlay = document.querySelector(selector);
    
    if (overlay && !drawer.contains(overlay)) {
      overlay.classList.add("active");
      overlay.style.setProperty("opacity", "1", "important");
      overlay.style.setProperty("visibility", "visible", "important");
      overlay.style.setProperty("display", "block", "important");
      overlay.style.setProperty("position", "fixed", "important");
      overlay.style.setProperty("inset", "0", "important");
      overlay.style.setProperty("z-index", "999996", "important");
      
      overlay.removeEventListener("click", handleOverlayClick);
      overlay.addEventListener("click", handleOverlayClick);
      
      console.log("✅ Overlay click attached:", selector);
    }
  }
  
  document.body.style.overflow = "hidden";
  document.body.classList.add("overflow-hidden");
  
  addPageBlur();
  
  if (button) {
    hideLoadingSpinner(button);
  }
  
  setupCartCloseButton();
  setupRemoveButtons();
  startCartDrawerObserver();
  
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  document.body.dispatchEvent(new CustomEvent('cart:refresh'));
  
  console.log("✅✅✅ Drawer opened with perfect alignment!");
}

/* ---------------------------------------------------------
   OCTANE QUIZ BUTTON LOGIC - AUTO OPEN CART DRAWER
--------------------------------------------------------- */
document.addEventListener("octane.quiz.completed", async function (event) {
  if (!location.href.includes('try-now-quiz')) return;
  if (!window.trynow) return;

  const productResults = event.detail.product_blocks;
  const addToCartButtons = document.querySelectorAll('#octane-quiz-wrapper button');

  addToCartButtons.forEach((button, index) => {
    const clonedButton = button.cloneNode(true);
    clonedButton.textContent = "Try Before You Buy";
    clonedButton.id = "trynow-quiz-cta-button-" + index;
    clonedButton.classList.add('trynow-quiz-cta-button');

    const product = productResults[index] && productResults[index][0];
    let variantId;

    if (!product) {
      variantId = null;
    } else if (!product.variants) {
      variantId = product.id;
    } else if (product.variants.length === 1) {
      variantId = product.variants[0].id;
    } else {
      variantId = product.variants.map(variant => variant.id);
    }

    clonedButton.dataset.variantId = JSON.stringify(variantId);

    clonedButton.addEventListener('click', async (event) => {
      const btn = event.target;

      btn.disabled = true;
      btn.textContent = "Adding…";

      try {
        let sellingPlanId = (await window.trynow.getSellingPlanId()).split('/').pop();
        let variant = JSON.parse(event.target.dataset.variantId);

        // Multiple variants case
        if (Array.isArray(variant)) {
          const variantSelect = document.querySelector('select[aria-label="Variant selector"]');
          if (variantSelect) {
            const selectedIndex = parseInt(variantSelect.value, 10);
            variant = variant[selectedIndex];
          }
        }

        // Add products to cart
        if (variant == null) {
          // Add all variants from all buttons
          let variantsToAdd = [];
          const buttons = document.querySelectorAll('.trynow-quiz-cta-button');

          buttons.forEach(button => {
            const variantsInButton = JSON.parse(button.dataset.variantId);
            if (Array.isArray(variantsInButton)) {
              const selectedVariant = document.querySelector('select[aria-label="Variant selector"]');
              if (selectedVariant) {
                const selectedVariantIndex = parseInt(selectedVariant.value, 10);
                variantsToAdd.push(variantsInButton[selectedVariantIndex]);
              }
            } else if (variantsInButton != null) {
              variantsToAdd.push(variantsInButton);
            }
          });

          // Add each variant
          for (const variantId of variantsToAdd) {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variantId,
                quantity: 1,
                selling_plan: sellingPlanId
              })
            });
            
            if (!response.ok) {
              console.error("Failed to add variant:", variantId);
            }
          }
        } else {
          // Add single variant
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variant,
              quantity: 1,
              selling_plan: sellingPlanId
            })
          });
          
          if (!response.ok) {
            throw new Error("Failed to add to cart");
          }
        }

        console.log("✅ Product(s) added to cart");

        // Update cart icon bubble
        updateCartIconBubbleFromCart();

        // ✨ AUTOMATICALLY OPEN CART DRAWER
        console.log("🎯 Auto-opening cart drawer after add to cart...");
        await openCartDrawerWithProducts(btn);
        
        // ✨ RESTORE BUTTON TEXT
        btn.textContent = "Try Before You Buy";
        btn.disabled = false;
        
        console.log("✅ Product added and cart opened");

      } catch (error) {
        console.error("❌ Error adding to cart:", error);
        btn.textContent = "Error - Try Again";
        btn.disabled = false;
      }
    });

    button.parentNode.style.display = 'none';
    button.parentNode.insertAdjacentElement('afterend', clonedButton);
  });
});

/* ---------------------------------------------------------
   CART CLOSE BUTTON HANDLER
--------------------------------------------------------- */
function setupCartCloseButton() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) {
    console.log("⚠️ Cart drawer not found yet");
    return;
  }

  // Find ONLY the drawer's close button
  const closeButton = drawer.querySelector("button.drawer__close");
  
  if (!closeButton) {
    console.log("❌ Drawer close button not found!");
    return;
  }

  console.log("✅ Found cart close button:", closeButton);

  // Remove any old listeners by cloning
  const newButton = closeButton.cloneNode(true);
  closeButton.parentNode.replaceChild(newButton, closeButton);

  // Add click handler
  newButton.addEventListener("click", function(e) {
    console.log("🔴 Cart close button clicked!");
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeCartDrawer();
  });

  console.log("✅ Cart close button handler attached!");
}

/* ---------------------------------------------------------
   OVERLAY CLICK HANDLER
--------------------------------------------------------- */
function handleOverlayClick(e) {
  if (e.target === e.currentTarget) {
    console.log("🔴 Overlay clicked!");
    closeCartDrawer();
  }
}

/* ---------------------------------------------------------
   GLOBAL CLICK INTERCEPTOR (BACKUP)
--------------------------------------------------------- */
document.addEventListener("click", function(e) {
  const drawer = document.querySelector("cart-drawer");
  
  // Only run if drawer is open
  if (!drawer || !drawer.hasAttribute("open")) {
    return;
  }

  // Check if clicked button is cart drawer close button
  if (e.target.matches("cart-drawer button.drawer__close") || 
      e.target.closest("cart-drawer button.drawer__close")) {
    console.log("🔴 BACKUP: Cart close intercepted!");
    e.preventDefault();
    e.stopPropagation();
    closeCartDrawer();
  }
}, true);


/* ---------------------------------------------------------
   QTY BUTTON CLICK HANDLER
--------------------------------------------------------- */
document.addEventListener("click", function (e) {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer || !drawer.hasAttribute("open")) return;

  // Detect +/- quantity buttons
  if (e.target.closest(".js-qty__adjust, [name='updates[]'], .quantity__button, button[name='plus'], button[name='minus']")) {
    console.log("🔢 Quantity button clicked!");
    
    // Force reapply styles immediately
    setTimeout(() => {
      applyCustomCartStyles();
      updateCartIconBubbleFromCart();
    }, 2000);
    console.log("♻️ Shopify done");
  }
});

/* ---------------------------------------------------------
   INITIALIZE FLOATING CART ICON ON PAGE LOAD
--------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  console.log("🎬 Page loaded - initializing floating cart icon");
  createFloatingCartIcon();
  showFloatingCartIcon();
});